import React, { useState, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import { connect } from 'react-redux';
import * as logger from '../../../logger';
import {
    TextField,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches,
    Checkboxes
} from 'mui-rff';
import { Form } from 'react-final-form';
import {
    Grid,
    IconButton,
    Button,
    Typography
} from '@material-ui/core';
import { fetchBankAccounts } from '../../../store/actions/authActionCreators';
import { updateChatView } from '../../../store/actions/userActionCreators';
import { markDefaultBank } from '../../../store/actions/OnlinePaymentActionCreators';
import { selectBankSideBarCss } from './InvoiceSideBarCss';
import AddBankDetailsDialog from "../Bank/AddBankDetailsDialog";
import AddIcon from '@material-ui/icons/Add';
import { VerifiedBankAccount, UnVerifiedBankAccount } from '../TopCard/icons';
import { sendError, sendSucces } from "../../../utils/utils"
import SuccessDialog from '../Verfication/SuccessDialog';
import FailureDialog from '../Verfication/FailureDialog';


const SelectBankSideBar = ({
    open,
    onClose,
    onConfirm,
    user,
    trips,
    dispatchFetchBankAccounts,
    dispatchMarkDeafultBank,
    dispatchChatView
}) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [defaultBank, setDefaultBank] = React.useState(null);
    const [bankList, setBankList] = React.useState([]);
    const [addBankDetails, setAddBankDetails] = useState(false);
    const [confirmDisabled, setConfirmDisabled] = useState(true);
    const [successCreation, setSuccessCreation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);
    const [selectedData, setSelectedData] = useState({});
    const [recall, setRecall] = useState(false);

    const classes = selectBankSideBarCss();

    const userData = trips && trips.singleInvoiceInfo ? trips.singleInvoiceInfo : {};

    let initialValues = {
        defaultBank: defaultBank
    };

    useEffect(() => {

        dispatchChatView(false);

        const requestData = {
            entity_type: [
                "FLEET_OWNER"
            ],
            entity_id: []
        }

        requestData.entity_id.push(user && user.userInfoProfile && user.userInfoProfile.entityId ? user.userInfoProfile.entityId : "")

        dispatchFetchBankAccounts(requestData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Select Bank Side Bar Dweb', 'Fetch Bank Accounts Successfull');
                    if (data.response) {
                        let bank = data.response.filter(v => v && v.is_default);
                        if (bank && bank[0] && bank[0].id && bank[0].broker_verification_status) {
                            setDefaultBank(`${bank[0].id}`);
                        }
                        setBankList(data.response);
                        setAddBankDetails(false);
                    }
                }
            },
            () => {
                logger.log('Select Bank Side Bar Dweb', 'Fetch Bank Accounts Failed');
            }
        );

    }, [open, recall]);

    const getFormFields = (values) => {
        return [{
            size: 12,
            visible: bankList && bankList.length > 0,
            inline: false,
            field: (
                <>
                    <Radios
                        label=""
                        name="defaultBank"
                        required={true}
                        formControlProps={{
                            margin: 'none',
                            className: classes.billingTypeRadio,
                            fullWidth: true
                        }}
                        onChange={(e) => {
                            setDefaultBank(e.target.value)
                        }}
                        formControlLabelProps={{
                            //control:<BlueRadio />,
                            className: classes.selectionDiv
                        }}
                        radioGroupProps={{ row: false }}
                        data={
                            createBankDataList(bankList && bankList.length > 0 ? bankList : [])
                        }
                        classes={{ root: classes.radioPadding }}
                    />
                </>
            ),
        },
        {
            size: 12,
            visible: true,
            inline: false,
            field: (
                <>
                    <Button className={classes.addBankDetailsButton} variant='outlined' onClick={() => { handleAddBankOpen() }}>
                        <AddIcon />
                        Add New Bank Account
                    </Button>
                </>
            ),
        }]
    }

    const createBankDataList = (bankList) => {
        let data = bankList.map((bank) => {
            return {
                value: `${bank.id}`,
                disabled: bank && !bank.broker_verification_status ? true : false,
                label: <div>
                    <Grid container>

                        <Grid container justify="space-between" wrap="nowrap">
                            <Grid container wrap="nowrap">
                                <Grid item className={classes.primary}>
                                    {bank && bank.acc_holder_name ? bank.acc_holder_name.toLowerCase() : "--"}
                                </Grid>
                                <Grid item>
                                    {bank && bank.broker_verification_status && <VerifiedBankAccount className={classes.iconV1} />}
                                    {bank && !bank.broker_verification_status && <UnVerifiedBankAccount className={classes.iconV1} />}
                                </Grid>
                            </Grid>
                            <Grid container wrap="nowrap" className={classes.paddingStart}>
                                <Grid item className={classes.fw600}>Acc No:&nbsp;</Grid>
                                <Grid item><span>{bank && bank.acc_number ? bank.acc_number : "--"}</span></Grid>
                            </Grid>
                        </Grid>

                        <Grid container wrap="nowrap">
                            <Grid container wrap="nowrap">
                                <Grid item>{bank && bank.bank_name ? bank.bank_name.toLowerCase() : "--"}</Grid>
                            </Grid>
                            <Grid container wrap="nowrap" className={classes.paddingStart}>
                                <Grid item><span className={classes.fw600}>UPI:&nbsp;</span>{bank && bank.upi_address ? bank.upi_address : "--"}</Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </div>
            }
        })
        return data
    }

    const validate = async values => {
        const errors = {};

        if (!values.defaultBank) {
            errors.defaultBank = "Please Select a Bank Account";
        }

        const selectedBank = bankList.filter((bankData) => bankData.id == values.defaultBank);

        if (selectedBank && selectedBank[0] && !selectedBank[0].broker_verification_status) {
            errors.defaultBank = "Please select a verified Bank Account"
        }

        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }


        return errors;
    }

    const onSubmit = async values => {
        const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
        await sleep(300);

        const selectedBankInfo = bankList.filter((bankData) => bankData.id == values.defaultBank);

        dispatchMarkDeafultBank({ id: Number(values.defaultBank) },
            (response) => {
                if (response && response.status && response.status.code == 200) {
                    sendSucces("Default Bank Account Changed Successfully");
                    onConfirm(true);
                }
            },
            () => {
                logger.log('Select Bank Side Bar Dweb', 'Mark Default Failed');
            });
    };

    const handleAddBankOpen = () => {
        setAddBankDetails(true);
        const dataValue = {
            id: user && user.userInfoProfile && user.userInfoProfile.entityId ? user.userInfoProfile.entityId : ""
        }
        setSelectedData(dataValue);
    }

    const handleAddBankClose = () => {
        setAddBankDetails(false);
    }

    const handleAddBankSave = (status) => {

        if (status) {
            handleSuccessOpen()
            setTimeout(() => {
                handleSuccessClose()
            }, 3000);
        } else {
            handleFailureOpen()
            setTimeout(() => {
                handleFailureClose()
            }, 3000);
        }

        setAddBankDetails(false);
        setRecall(!recall);
    }

    const handleSuccessOpen = () => {
        setSuccessCreation(true)
    }
    const handleSuccessClose = () => {
        setSuccessCreation(false)
    }
    const handleFailureOpen = () => {
        setFailureCreation(true)
    }
    const handleFailureClose = () => {
        setFailureCreation(false)
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        dispatchChatView(true);
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >
                <SideBarDialogTitle id={"right-sidebar-for-select-bank"} onClose={handleClose} className={classes.dialogTitle} >
                    <div className={classes.divTitle}>
                        Choose Account
                    </div>
                </SideBarDialogTitle >

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >
                    <div>
                        <Form
                            onSubmit={onSubmit}
                            initialValues={initialValues}
                            validate={validate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                submit = handleSubmit; return (
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Grid container alignItems="flex-start" spacing={0}>
                                            {getFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />
                    </div>
                </SideBarDialogContent>

                <SideBarDialogActions className={classes.dialogActions} >

                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()}>
                        Close
                    </Button>
                    <Button variant="contained" className={classes.saveButton} classes={{ disabled: classes.saveButtonDisabled }} disabled={confirmDisabled}
                        onClick={event => submit(event)}
                    >
                        Make Default
                    </Button>

                </SideBarDialogActions>
            </Drawer>

            {addBankDetails && <AddBankDetailsDialog type={"FLEET_OWNER"} selectedData={selectedData} open={addBankDetails} onClose={handleAddBankClose} onSave={handleAddBankSave} calledFrom={"invoice"} />}
            {successCreation && <SuccessDialog open={successCreation} title={"Account Verified Successfully"} onClose={handleSuccessClose} />}
            {failureCreation && <FailureDialog open={failureCreation} title={"Account Verification Failed"} subTitle={"Please Re-Check the Bank Account details"} onClose={handleFailureClose} />}
        </>
    )
}

export const mapStateToProps = (state) => (state);
export const mapDispatchToProps = (dispatch) => ({

    dispatchFetchBankAccounts: (data, onSuccess, onError) => {
        dispatch(fetchBankAccounts(data, onSuccess, onError))
    },
    dispatchMarkDeafultBank: (data, onSuccess, onFailure) => {
        dispatch(markDefaultBank(data, onSuccess, onFailure))
    },
    dispatchChatView: (value) => {
        dispatch(updateChatView(value))
    },

});

export default connect(mapStateToProps, mapDispatchToProps)(SelectBankSideBar);